import { User } from './user';
const MINUTE_SECONDS = 60;
const HOUR_SECONDS = 3600;
const DAY_SECONDS = 86400;
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const SUPPORTED_MEDIA = ['photo', 'animated_gif'];
export class Status {
    constructor(parent) {
        let status = Object.assign({}, parent);
        if (status.retweeted_status) {
            let retweet = status;
            status = Object.assign({}, status.retweeted_status);
            delete retweet.retweeted_status;
            this.retweet = new Status(retweet);
        }
        this._user = new User(status.user);
        this._data = status;
    }
    get id_str() {
        return this._data.id_str;
    }
    get user() {
        return this._user;
    }
    get url() {
        return `https://twitter.com/${this._user.screen_name}/status/${this._data.id_str}`;
    }
    get mediaType() {
        return this.firstMedia ? this.firstMedia.type : 'none';
    }
    get mediaUrl() {
        const media = this.firstMedia;
        if (media && media.video_info && media.video_info.variants) {
            return media.video_info.variants[0].url;
        }
        else if (media) {
            return media.media_url_https;
        }
        else {
            return '';
        }
    }
    get fallbackMediaUrl() {
        const media = this.firstMedia;
        if (media) {
            return media.media_url_https;
        }
        else {
            return '';
        }
    }
    get firstMedia() {
        if (this._data.extended_entities && this._data.extended_entities.media) {
            return this._data.extended_entities.media.find(media => {
                return SUPPORTED_MEDIA.includes(media.type);
            });
        }
        else {
            return;
        }
    }
    get text() {
        const media = this.firstMedia;
        return media ? this._data.full_text.replace(media.url, '').trim() : this._data.full_text;
    }
    get entities() {
        return this._data.entities;
    }
    get createdAt() {
        return new Date(Date.parse(this._data.created_at));
    }
    get relativeCreatedAt() {
        return this.relativeDate(this.createdAt);
    }
    get replyUrl() {
        return `https://twitter.com/intent/tweet?in_reply_to=${this._data.id_str}`;
    }
    get retweetUrl() {
        return `https://twitter.com/intent/retweet?tweet_id=${this._data.id_str}`;
    }
    get likeUrl() {
        return `https://twitter.com/intent/like?tweet_id=${this._data.id_str}`;
    }
    relativeDate(date) {
        const now = new Date();
        const delta = (now.getTime() - date.getTime()) / 1000;
        if (delta <= 604800) {
            return this.shortForm(delta);
        }
        else {
            const day = date.getDate();
            const month = MONTHS[date.getMonth()];
            const year = date.getFullYear() == now.getFullYear() ? '' : ` ${date.getFullYear()}`;
            return `${day} ${month}${year}`;
        }
    }
    shortForm(delta) {
        if (delta < MINUTE_SECONDS) {
            return `${Math.round(delta)}s`;
        }
        if (delta < HOUR_SECONDS) {
            return `${Math.round(delta / MINUTE_SECONDS)}m`;
        }
        if (delta < DAY_SECONDS) {
            return `${Math.round(delta / HOUR_SECONDS)}h`;
        }
        return `${Math.round(delta / DAY_SECONDS)}d`;
    }
}
//# sourceMappingURL=status.js.map